export default {
    finance: {
        loanPrograms: {
            title: "Programmi di prestito",
            create: "Crea programma di prestito",
            edit: "Modifica programma di prestito",
            details: "Dettagli programma",
            programTitle: "Titolo programma",
            programLogo: "Logo programma",
            applicationForm: "Modulo di domanda",
            viewApplications: "Visualizza domande",
            cooperative: "Cooperativa",
            bank: "Banca",
            status: "Stato",
            allStatuses: "Tutti gli stati",
            active: "Attivo",
            inactive: "Inattivo",
            approvalFlowSetting: "Impostazione flusso di approvazione",
            concludeBeforeBank: "Concludi una domanda di prestito prima di inviarla alla banca.",
            allowBankRequestInfo: "Consenti alla banca di richiedere ulteriori informazioni al richiedente.",
            currency: "Valuta",
            loanAmountMin: "Importo prestito - Minimo",
            loanAmountMax: "Importo prestito - Massimo",
            term: "Durata",
            yield: "Rendimento",
            typeOfFinancing: "Tipo di finanziamento",
            gracePeriod: "Periodo di grazia",
            country: "Paese",
            regions: "Regioni",
            crops: "Colture",
            dataFields: "Campi dati",
            dataFieldsConfigured: "Campi dati configurati per questo programma di prestito",
            signature: "Firma",
            viewSignatureFile: "Visualizza firma / file",
            description: "Descrizione",
            conditionsRequirements: "Condizioni e requisiti",
            digitalSignature: "Firma digitale",
            fileUpload: "Caricamento file",
            failedLoadLoanProgramDetails: "Impossibile caricare i dettagli del programma di prestito",
            failedLoadLoanProgram: "Impossibile caricare il programma di prestito",
            failedLoadApplicationForm: "Impossibile caricare il modulo di domanda",
            loanProgramUpdatedSuccess: "Programma di prestito aggiornato con successo",
            loanProgramCreatedSuccess: "Programma di prestito creato con successo",
            applicationFormUpdatedSuccess: "Modulo di domanda aggiornato con successo",
            failedUpdateLoanProgram: "Impossibile aggiornare il programma di prestito",
            failedCreateLoanProgram: "Impossibile creare il programma di prestito",
            failedUpdateApplicationForm: "Impossibile aggiornare il modulo di domanda",
            fillRequiredFields: "Compila tutti i campi obbligatori",
            fileUploadRequiredFor: "E richiesto il caricamento di un file per",
            selectAtLeastOneOptionFor: "Seleziona almeno un opzione per",
            fieldRequired: "Questo campo e obbligatorio",
            chooseValidOptionFor: "Scegli un opzione valida per",
            enterValidAmountFor: "Inserisci un importo valido per",
            selectValidUnitFor: "Seleziona un unita valida per",
            step1ProgramDetails: "Passo 1: Dettagli programma",
            step2ApplicationForm: "Passo 2: Modulo di domanda",
            months: "mesi",
            years: "anni",
            days: "giorni",
            weeks: "settimane",
            previewForm: "ANTEPRIMA MODULO",
            backUpper: "INDIETRO",
            basicInformation: "Informazioni di base",
            basicInformationHint: "Inserisci le informazioni di base per il programma di prestito.",
            enterProgramTitle: "Inserisci il titolo del programma",
            attachProgramLogo: "Allega il logo del programma",
            selectProgramLogoImage: "Seleziona l immagine del logo del programma",
            selectFileUploadProgramLogo: "Seleziona il file per caricare il logo del programma",
            orDragDrop: "oppure trascina e rilascia qui",
            removeFile: "Rimuovi file",
            loanProgramSettings: "Impostazioni programma di prestito",
            loanProgramSettingsHint: "Inserisci le impostazioni del programma di prestito.",
            selectBank: "Seleziona banca",
            applicationApproval: "Approvazione domanda",
            applicationProcess: "Processo di domanda",
            loanDetails: "Dettagli del prestito",
            loanDetailsHint: "Inserisci i dettagli del prestito per il programma.",
            selectCurrency: "Seleziona valuta",
            enterMinLoanAmount: "Inserisci importo minimo del prestito",
            enterMaxLoanAmount: "Inserisci importo massimo del prestito",
            enterHere: "Inserisci qui",
            interestRate: "Tasso di interesse",
            yieldPerYear: "Rendimento - per anno",
            enterYieldPerYear: "Inserisci il rendimento annuo",
            selectTypeOfFinancing: "Seleziona tipo di finanziamento",
            gracePeriodMax: "Periodo di grazia - Massimo",
            selectCrops: "Seleziona colture",
            selectCountry: "Seleziona paese",
            selectRegions: "Seleziona regioni",
            addNewDataField: "AGGIUNGI NUOVO CAMPO DATI",
            enterProgramDescription: "Inserisci la descrizione del programma",
            programApplicationForm: "Modulo di domanda del programma",
            defineAndManageCustomDataFields: "Definisci e gestisci campi dati personalizzati per la domanda di prestito.",
            addDataField: "AGGIUNGI CAMPO DATI",
            dataField: "Campo dati",
            type: "Tipo",
            subdata: "Sottodato",
            mandatory: "Obbligatorio",
            group: "Gruppo",
            yes: "Si",
            no: "No",
            noDataFieldsYet: "Nessun campo dati aggiunto. Fai clic su AGGIUNGI CAMPO DATI per crearne uno.",
            textField: "Campo di testo",
            textArea: "Area di testo",
            textFieldNumeric: "Campo numerico",
            radioButton: "Pulsante radio",
            checkBoxes: "Caselle di controllo",
            dropdown: "Menu a tendina",
            measurementUnit: "Unita di misura",
            attachFile: "Allega file",
            digitalSignatureLabel: "Firma digitale",
            dataList: "Elenco dati",
            date: "Data",
            selectDataType: "Seleziona tipo di dato",
            fieldTitle: "Titolo campo",
            groupTitle: "Titolo gruppo",
            enterGroupTitle: "Inserisci titolo gruppo",
            allowMultipleInputs: "Consenti input multipli",
            allowedFileTypes: "Tipi di file consentiti",
            imageJpegGifPng: "Immagine (JPEG, GIF, PNG)",
            videoMp4: "Video (MP4)",
            docx: "DOCX",
            options: "Opzioni",
            typeHere: "Scrivi qui",
            unitType: "Tipo unita",
            selectUnitType: "Seleziona tipo unita",
            selectType: "Seleziona tipo",
            allowUserToChangeUnitType: "Consenti all utente di cambiare tipo di unita",
            help: "Aiuto",
            writeHelpTextUsers: "Scrivi un testo di aiuto per gli utenti.",
            helpText: "Testo di aiuto",
            addHelpTextForThisDataField: "Aggiungi testo di aiuto per questo campo dati",
            addFieldToGroup: "Aggiungi campo al gruppo",
            cancelUpper: "ANNULLA",
            submitUpper: "INVIA",
            groupTitleRequired: "Il titolo del gruppo e obbligatorio",
            atLeastOneFieldRequiredInGroup: "Almeno un campo e obbligatorio in un gruppo",
            fieldTitleRequiredForAllGroupFields: "Il titolo del campo e obbligatorio per tutti i campi del gruppo",
            atLeastOneOptionRequiredFor: "Almeno un opzione e obbligatoria per",
            atLeastOneFileTypeMustBeSelected: "Deve essere selezionato almeno un tipo di file",
            fieldTitleRequired: "Il titolo del campo e obbligatorio",
            atLeastOneOptionRequired: "Almeno un opzione e obbligatoria",
        },
        loanApplications: {
            activityDescription: "Descrizione attivita",
            activityLog: "Registro attivita",
            addAnyInternalNotesOrReviewCommentsAboutThisLoanApplication: "Aggiungi note interne o commenti di revisione su questa domanda di prestito.",
            additionalInformationRequested: "Informazioni aggiuntive richieste",
            additionalLoanRelatedQuestionsAndSupportingDocuments: "Domande aggiuntive sul prestito e documenti di supporto.",
            additionalQuestions: "Domande aggiuntive",
            address: "Indirizzo",
            amount: "Importo",
            applicantDetails: "Dati del richiedente",
            applicationHasBeenSentToTheBankForApproval: "La domanda e stata inviata alla banca per l'approvazione.",
            applicationId: "ID domanda",
            applicationIdAndSubmissionDate: "ID domanda e data di invio",
            apply: "Applica",
            approvalProcess: "Processo di approvazione",
            approvalProcessHasBeenStartedYouCanNowFillFinalizeContractAndLoanDetails: "Il processo di approvazione e stato avviato. Ora puoi compilare Finalizza contratto e Dettagli prestito.",
            approve: "Approva",
            approved: "Approvato",
            areYouSureYouWantToApproveTheLoanApplication: "Sei sicuro di voler approvare la domanda di prestito?",
            areYouSureYouWantToRejectTheLoanApplication: "Sei sicuro di voler rifiutare la domanda di prestito?",
            areYouSureYouWantToSendTheApplicationToTheBankForApprovalProcess: "Sei sicuro di voler inviare la domanda alla banca per il processo di approvazione?",
            areYouSureYouWantToStartTheApprovalProcess: "Sei sicuro di voler avviare il processo di approvazione?",
            area: "Superficie",
            areaHa: "Superficie (ha)",
            attachContractOptional: "Allega contratto (facoltativo)",
            attachment: "Allegato",
            back: "Indietro",
            cancel: "Annulla",
            circular: "Circolare",
            close: "Chiudi",
            closeUpper: "CHIUDI",
            confirm: "Conferma",
            confirmation: "Conferma",
            contract: "Contratto",
            couldNotLoadLoanApplication: "Impossibile caricare la domanda di prestito.",
            couldNotSendRequest: "Impossibile inviare la richiesta.",
            couldNotUpdateApplication: "Impossibile aggiornare la domanda.",
            country: "Paese",
            customization: "Personalizzazione",
            date: "Data",
            dateAndTime: "Data e ora",
            describeHere: "Descrivi qui",
            description: "Descrizione",
            digitallySigned: "Firmato digitalmente",
            disclaimerTitle: "Disclaimer",
            disbursedAmount: "Importo erogato",
            disbursementScheduleFromBankToFarmer: "Piano di erogazione dalla banca all'agricoltore.",
            doYouWantUsToCollectTheContractSignature: "Vuoi che raccogliamo la firma del contratto?",
            doYouWantUsToCollectTheContractSignatureIfYesAttachTheContractOptionalAndWeWillSendItToTheFarmerToSignInTheAppIfNoTheContractIsAlreadySignedOrWillBeSignedOfflineAfterYouAttachAndSaveTheContractWillBeSentToTheFarmerToSignYouLlReceiveANotificationOnceItSSigned: "Vuoi che raccogliamo la firma del contratto? Se si, allega il contratto (facoltativo) e lo invieremo all'agricoltore per la firma nell'app. Se no, il contratto e gia firmato o sara firmato offline. Dopo aver allegato e salvato, il contratto verra inviato all'agricoltore per la firma; riceverai una notifica una volta firmato.",
            download: "Scarica",
            dueDate: "Data di scadenza",
            email: "Email",
            enterHere: "Inserisci qui",
            error: "Errore",
            farm: "Azienda agricola",
            farmDetails: "Dettagli azienda",
            farmReports: "Report azienda",
            farmer: "Agricoltore",
            farmerResponse: "Risposta dell'agricoltore",
            farmerUpdates: "Aggiornamenti dell'agricoltore",
            farmReportsSoilDisclaimer: "Le informazioni in questa sezione sono solo di riferimento generale. Non sostituiscono un'analisi del suolo professionale in laboratorio. Usale solo se altre opzioni di analisi non sono disponibili. Consulta sempre esperti agricoli prima di decidere.",
            farmReportsYieldBullet1: "E impossibile prevedere con precisione il meteo per tutta la stagione; in alcuni casi gli agricoltori possono perdere tutto il raccolto per grandine o alluvione (soprattutto con il riscaldamento globale e le sue irregolarita).",
            farmReportsYieldBullet2: "Le rese dipendono molto dalle pratiche di gestione. Ad esempio, se non si irrorano pesticidi al momento giusto o l'irrigazione e insufficiente, le rese possono differire molto dalle previsioni; anche questo e al di fuori del nostro controllo.",
            farmReportsYieldBullet3: "Molti altri fattori simili possono causare errori significativi nelle previsioni di resa basate su IA.",
            farmReportsYieldBullet4: "Se l'agricoltore fornisce rese storiche (modalita AVANZATA), le previsioni tendono ad essere piu accurate rispetto alla modalita predefinita (non AVANZATA).",
            farmReportsYieldUncertaintyIntro: "Nelle nostre previsioni di resa l'incertezza puo essere al 100% perche molti fattori sono al di fuori del nostro controllo, tra cui:",
            forecastedYields: "Rese previste",
            graph: "Grafico",
            yieldsKgAxis: "Rese (kg)",
            yieldForecasts: "Previsioni di resa",
            farmerUploadedAttachmentS: "L'agricoltore ha caricato allegato/i.",
            finalizeContract: "Finalizza contratto",
            financeManagement: "Gestione finanziaria",
            firstName: "Nome",
            generatePaymentSchedule: "GENERA PIANO DI PAGAMENTO",
            geolocation: "Geolocalizzazione",
            gracePeriod: "Periodo di grazia",
            gracePeriodType: "Tipo di periodo di grazia",
            historyOfActionsTakenOnThisLoanApplication: "Cronologia delle azioni su questa domanda di prestito.",
            ifYouWantUsToCollectTheApplicantSSignatureChooseYesAndAttachTheContractAfterYouSaveItWillBeSentToTheFarmerToSignInTheAppYouLlReceiveANotificationOnceSignedContractUploadIsOptionalEGIfTheContractIsAlreadySignedOrWillBeSignedOffline: "Se vuoi che raccogliamo la firma del richiedente, scegli Si e allega il contratto. Dopo il salvataggio verra inviato all'agricoltore per la firma nell'app; riceverai una notifica una volta firmato. Il caricamento del contratto e facoltativo (es. gia firmato o da firmare offline).",
            information: "Informazioni",
            informationRequestedFromBank: "Informazioni richieste alla banca",
            installment: "Rata",
            installmentDetails: "Dettagli rata",
            interestRate: "Tasso di interesse",
            ipAddress: "Indirizzo IP",
            keySoilNutrientLevelsForTheFarm: "Livelli chiave di nutrienti del suolo per l'azienda.",
            landSuitabilityReport: "Report di idoneita del terreno",
            lastName: "Cognome",
            loadingData: "Caricamento dati...",
            loanAmount: "Importo prestito",
            loanApplicationDetails: "Dettagli domanda di prestito",
            loanApplicationHasBeenApproved: "La domanda di prestito e stata approvata.",
            loanApplicationHasBeenRejected: "La domanda di prestito e stata rifiutata.",
            loanApplications: "Domande di prestito",
            loanDetails: "Dettagli prestito",
            loanDetailsSummary: "Riepilogo dettagli prestito.",
            loanDisbursementBankFarmer: "Erogazione prestito (Banca -> Agricoltore)",
            loanDisbursementPlan: "Piano di erogazione prestito",
            loanProgram: "Programma prestiti",
            loanPrograms: "Programmi prestiti",
            loanRepaymentFarmerBank: "Rimborso prestito (Agricoltore -> Banca)",
            loanRepaymentPlan: "Piano di rimborso prestito",
            missingApplicationId: "ID domanda mancante.",
            moderate: "Moderato",
            notApplicable: "N/D",
            nitrogenContent: "Contenuto di azoto",
            noAdditionalQuestions: "Nessuna domanda aggiuntiva.",
            noContractIsAlreadySignedOrWillBeSignedOffline: "No — il contratto e gia firmato o sara firmato offline",
            noMapCoordinatesForThisFarm: "Nessuna coordinata mappa per questa azienda.",
            notes: "Note",
            numberOfDisbursements: "Numero di erogazioni",
            numberOfInstallments: "Numero di rate",
            of: "di",
            openFile: "Apri file",
            orDragAndDropHere: "oppure trascina qui",
            overallLandSuitabilityScoreAndCategory: "Punteggio e categoria complessiva di idoneita del terreno.",
            overallScoreForLandSuitability: "Punteggio complessivo di idoneita del terreno",
            paid: "Pagato",
            paymentDetails: "Dettagli pagamento",
            payments: "Pagamenti",
            pending: "In sospeso",
            phoneNumber: "Numero di telefono",
            phosphorusContent: "Contenuto di fosforo",
            pleaseEnterAValidInterestRateToGenerateRepaymentPlan: "Inserisci un tasso di interesse valido per generare il piano di rimborso.",
            pleaseEnterAValidLoanAmountToGenerateDisbursementPlan: "Inserisci un importo prestito valido per generare il piano di erogazione.",
            pleaseEnterAValidLoanAmountToGenerateRepaymentPlan: "Inserisci un importo prestito valido per generare il piano di rimborso.",
            pleaseEnterNumberOfInstallmentsToGenerateRepaymentPlan: "Inserisci il numero di rate per generare il piano di rimborso.",
            pleaseEnterYourCommentsOrInstructions: "Inserisci commenti o istruzioni.",
            pleaseProvideSpecificCommentsOrInstructionsInTheTextBoxBelowOnceSubmittedTheFarmerWillBeNotifiedYouWillBeNotifiedWhenTheFarmerUpdatesTheApplication: "Fornisci commenti o istruzioni specifiche nel campo sottostante. Dopo l'invio l'agricoltore verra avvisato. Riceverai una notifica quando l'agricoltore aggiorna la domanda.",
            polygon: "Poligono",
            potassiumContent: "Contenuto di potassio",
            principalAndInterest: "Capitale e interessi",
            print: "Stampa",
            projectedYieldComparisonByYear: "Confronto rese previste per anno.",
            provinceState: "Provincia / Stato",
            question: "Domanda",
            recordsPerPage: "Record per pagina",
            regionDistrict: "Regione / Distretto",
            reject: "Rifiuta",
            rejected: "Rifiutato",
            repaymentScheduleFromFarmerToBank: "Piano di rimborso dall'agricoltore alla banca.",
            requestAdditionalInformation: "Richiedi informazioni aggiuntive",
            restoreDefault: "Ripristina predefiniti",
            search: "Cerca",
            select: "Seleziona",
            selectFileToUploadTheContract: "Seleziona il file per caricare il contratto",
            selectNoIfYouHaveAlreadySignedTheContractWithTheApplicantFarmerSelectYesIfYouWantTheApplicantFarmerToSignTheLoanContractOnHisDimitraMobileApp: "Seleziona No se hai gia firmato il contratto con il richiedente (agricoltore). Seleziona SI se vuoi che il richiedente (agricoltore) firmi il contratto di prestito nell'app mobile Dimitra.",
            send: "Invia",
            sendToBank: "Invia alla banca",
            sentToBank: "Inviato alla banca",
            signedOffline: "Firmato offline",
            soilAnalysisReport: "Report analisi del suolo",
            someDisclaimerOrShortExplainerAboutFollowingReports: "Breve disclaimer o spiegazione sui report seguenti.",
            srd: "SRD",
            startDate: "Data di inizio",
            status: "Stato",
            statusLegend: "Legenda stati",
            submissionDate: "Data di invio",
            success: "Operazione riuscita",
            tapTheMapToExpandIt: "Tocca la mappa per ingrandirla.",
            thisSectionShowsAdditionalInformationRequestsSentToTheFarmerAndTheirResponses: "Questa sezione mostra le richieste di informazioni aggiuntive inviate all'agricoltore e le relative risposte.",
            thisSectionShowsAdditionalInformationRequestsSentToTheFarmerAndTheirResponsesYouWillBeNotifiedWhenTheFarmerUpdatesTheApplication: "Questa sezione mostra le richieste di informazioni aggiuntive inviate all'agricoltore e le relative risposte. Riceverai una notifica quando l'agricoltore aggiorna la domanda.",
            totalInstallments: "Totale rate",
            totalInterestApprox: "Interessi totali (appross.)",
            totalLoanAmount: "Importo totale prestito",
            totalPayment: "Pagamento totale",
            totalRepayment: "Rimborso totale",
            transactionIdAndDate: "ID transazione e data",
            typeYourLocationNameAddress: "Digita nome o indirizzo della posizione",
            upcoming: "In arrivo",
            uploadTheUnsignedContractAfterYouAttachAndSaveItWillBeSentToTheFarmerToSignYouLlReceiveANotificationOnceItSSigned: "Carica il contratto non firmato. Dopo aver allegato e salvato, verra inviato all'agricoltore per la firma. Riceverai una notifica una volta firmato.",
            user: "Utente",
            userDetails: "Dettagli utente",
            userRole: "Ruolo utente",
            validation: "Validazione",
            viewFullReport: "Vedi report completo",
            viewGeolocation: "Vedi geolocalizzazione",
            villageTownCity: "Paese / Citta",
            waitingSignatures: "In attesa di firme",
            warning: "Avviso",
            year2025: "2025",
            year2026: "2026",
            yesAttachTheContractAndWeLlSendItToTheFarmerToSignInTheApp: "Si — allega il contratto e lo invieremo all'agricoltore per la firma nell'app",
            yieldPredictionReport: "Report previsione rese",
            youMayUploadTheSignedContractForYourRecordsOrLeaveEmptyIfTheContractIsPrivateOrSignedOffline: "Puoi caricare il contratto firmato per archivio oppure lasciare vuoto se e privato o firmato offline.",
            yourRequestHasBeenSentTheFarmerWillBeNotified: "La richiesta e stata inviata. L'agricoltore verra avvisato.",
            yieldForecastChartAria: "Grafico previsione rese",
            yearsAxisLabel: "Anni",
            soilAnalysisSectionTitle: "Analisi del suolo",
            soilMetricNitrogenN: "Azoto (N)",
            soilMetricPhosphorusP: "Fosforo (P2O5)",
            soilMetricPotassiumK: "Potassio (K2O)",
            soilAnalysisPlaceholderTitle: "Cosa significa (segnaposto)",
            soilAnalysisPlaceholderBody: "Questa pagina mostra un riepilogo semplificato dei nutrienti del suolo. Quando la fonte dati del backend sara integrata, la sezione potra essere ampliata con grafici completi del profilo del suolo e raccomandazioni.",
            landSuitabilitySectionTitle: "Idoneita del terreno",
            overallSuitabilityScoreLabel: "Punteggio complessivo di idoneita",
            suitabilityFactorsPlaceholder: "Fattori di idoneita (segnaposto)",
            factorSoilQuality: "Qualita del suolo",
            factorClimateFit: "Adeguamento climatico",
            factorWaterAvailability: "Disponibilita idrica",
            factorRiskFactors: "Fattori di rischio",
            landSuitabilityExpertFooter: "L'IA puo sbagliare; verifica con agronomi locali prima di decidere.",
        },
        banks: {
            title: 'Banche',
            addNewBank: 'Aggiungi nuova banca',
            bankDetails: 'Dettagli banca',
            bank: 'Banca',
            bankTitle: 'Titolo banca',
            attachBankLogo: 'Allega logo banca',
            addImage: 'Aggiungi immagine',
            contactDetails: 'Dettagli contatto',
            firstName: 'Nome',
            lastName: 'Cognome',
            email: 'Email',
            phone: 'Numero di telefono',
            enterHere: 'Inserisci qui',
            apiIntegrationInfo: 'Informazioni integrazione API',
            apiBaseUrl: 'URL base API',
            clientId: 'ID client / Chiave pubblica',
            clientSecret: 'Segreto client / Chiave privata',
            accountAdminCredentials: 'Credenziali account/amministratore',
            adminUsername: 'Nome utente amministratore',
            password: 'Password',
            require2FA: 'Richiedi 2FA',
            enable: 'Abilita',
            copy: 'Copia',
            regenerate: 'Rigenera',
            edit: 'Modifica',
            back: 'Indietro',
            cancel: 'Annulla',
            save: 'Salva',
            firstNameInfo: 'Informazioni nome',
            lastNameInfo: 'Informazioni cognome',
            emailInfo: 'Informazioni email',
            phoneInfo: 'Informazioni numero di telefono',
            apiBaseUrlInfo: 'Informazioni URL base API',
            clientIdInfo: 'Informazioni ID client',
            clientSecretInfo: 'Informazioni segreto client',
            adminUsernameInfo: 'Informazioni nome utente amministratore',
            passwordInfo: 'Informazioni password',
            contactPerson: 'Persona di contatto',
            management: 'Gestione finanziaria',
            editBank: 'Modifica banca',
            changeImage: 'Cambia immagine',
            failedToLoadBankDetails: 'Impossibile caricare i dettagli della banca',
            bankUpdatedSuccessfully: 'Banca aggiornata con successo',
            bankCreatedSuccessfully: 'Banca creata con successo',
            errorUpdatingBank: 'Errore durante l aggiornamento della banca',
            errorCreatingBank: 'Errore durante la creazione della banca',
            bankLogo: 'Logo della banca',
            bankLogoPreview: 'Anteprima del logo della banca',
            notAvailable: 'N/D',
        },
        dashboard: {
            title: "Dashboard finanziaria",
            avgLoanAmount: "Importo medio prestito",
            vsLastMonth: "vs mese scorso",
            totalApplications: "Domande totali",
            approvalRate: "Tasso di approvazione",
            loanApplicationsChart: "Domande di prestito",
            applicationsByStatus: "Domande per stato",
            applicationsByRegion: "Domande per regione",
            regionBreakdown: "Ripartizione per regione",
            averageLoanAmountTrend: "Andamento importo medio prestito",
            loanAmountOverTime: "Importo prestito nel tempo",
            avgAmount: "Importo medio"
        },
        status: {
            approved: "Approvato",
            pending: "In sospeso",
            waiting: "In attesa",
            rejected: "Rifiutato"
        },
        reports: {
            today: "Oggi",
            week: "Settimana",
            month: "Mese",
            year: "Anno"
        },
    },
}
